export default __webpack_public_path__ + "static/media/care.5b44c29a.png";